import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";
import OffsetLine from "../Lines/OffsetLine";

export class Circle extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'circle', dimensions );
	}

	getLength(): Length {
		return this.cleanedPrimitives.diameter;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.diameter;
	}

	getHeight(): Length {
		return this.cleanedPrimitives.diameter;
	}

	getDiameter(): Length {
		return this.cleanedPrimitives.diameter;
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'diameter' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		const dimensionLines = [];

		if(focusedElement.includes("cutout_measurement") || forceRender) {
			dimensionLines.push(
				new DimensionLine( [-this.getDiameter().divide(2).in_mm(), -this.getDiameter().divide(2).in_mm()], [ -this.getDiameter().divide(2).in_mm(), this.getDiameter().divide(2).in_mm() ], this.renderDimensionLabel( 'height', this.getWidth() ), [-40, 0], ratio ), // Vertical line
				new DimensionLine( [-this.getDiameter().divide(2).in_mm(), -this.getDiameter().divide(2).in_mm()], [ this.getDiameter().divide(2).in_mm(), -this.getDiameter().divide(2).in_mm() ], this.renderDimensionLabel( 'width', this.getWidth() ), [0, -40], ratio ) // Horizontal line
			);
		}

		if(focusedElement.includes("measurements-circle-diameter")) {
			dimensionLines.push(
				new DimensionLine( [-this.getDiameter().divide(2).in_mm(), 0], [ this.getDiameter().divide(2).in_mm(), 0 ], this.renderDimensionLabel( 'diameter' ), [0, 0], ratio, this.getDimensionLineType('measurements-circle-diameter', focusedElement, forceRender) ) // Horizontal line
			);
		}

		return dimensionLines;
	}

	getDefaultDimensions(): Dimensions {
		return { diameter: 50 };
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();

		return {
			diameter: width.divide(2).in_cm(),
		};
	}
}
